module.exports = __webpack_public_path__ + "img/TRANSITIONS-SIGNATURE-1.a1ac1dfe.gif";